import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { ParticipantDashboardDataSelector } from "../../redux/selectors/participantDashboardSelector";

import InventoryIcon from "../../assets/styles/images/inventory.png";
import EvaluationIcon from "../../assets/styles/images/evaluation.png";
import FollowupIcon from "../../assets/styles/images/follow-up.png";
import IctInitialInventoryIcon from "../../assets/styles/images/ict-initial-inventory.png";
import IctPostInventoryIcon from "../../assets/styles/images/ict-post-inventory.png";
import IctEvaluationIcon from "../../assets/styles/images/ict-evaluation.png";
import IctFollowupIcon from "../../assets/styles/images/ict-followup.png";
import Logo from "../../assets/styles/images/logo.png";

function QuestionHeader(props) {
  
  const participantDashBoardData = useSelector(ParticipantDashboardDataSelector);
  const [prevUrlPage] = useState(participantDashBoardData?.page || 1);

  const getIconSrc = () => {
    switch (props?.type) {
      case 1:
        return InventoryIcon;
      case 2:
        return EvaluationIcon;
      case 3:
        return FollowupIcon;
      case 4:
        return IctInitialInventoryIcon;
      case 5:
        return IctPostInventoryIcon;
      case 6:
        return IctEvaluationIcon;
      case 7:
        return IctFollowupIcon;
      default:
        return InventoryIcon;
    }
  };

  const getTitle = () => {
    switch (props?.type) {
      case 1:
        return "インベントリー";
      case 2:
        return "エバリュエーション";
      case 3:
        return "フォローアップアンケート";
      case 4:
        return "インベントリー1回目";
      case 5:
        return "インベントリー2回目";
      case 6:
        return "エバリュエーション";
      case 7:
        return "フォローアップアンケート";
      default:
        return "インベントリー";
    }
  };

  const getBackLink = () => {
    switch (props?.type) {
      case 1:
        return "/participants/inventories?&page=" + prevUrlPage;
      case 2:
        return "/participants/evaluations?&page=" + prevUrlPage;
      case 3:
        return "/participants/followups?&page=" + prevUrlPage;
      case 4:
        return "/participants/ict/initial-inventories?&page=" + prevUrlPage;
      case 5:
        return "/participants/ict/post-inventories?&page=" + prevUrlPage;
      case 6:
        return "/participants/ict/evaluations?&page=" + prevUrlPage;
      case 7:
        return "/participants/ict/followups?&page=" + prevUrlPage;
      default:
        return "/participants/inventories?&page=" + prevUrlPage;
    }
  };

  return (
    <>
      <header>
        <div className="container w40 max-width-900">
          <div className="row align-items-center header_height">
            <div className="col-4 border-end">
              <Link to={"/participants/home?tab=0"} className='assessment-portal-link p-0 py-3'>Learning Compass</Link>

            </div>
            <div className="col-8">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <div><img src={getIconSrc()} className="w42" alt="Icon" /></div>
                  <div className="ms-2"><h3 className="fnt20 fw-bold question-head-text">{getTitle()}</h3></div>
                </div>
                <div className='mt-1'>
                  <Link to={getBackLink()} className="top_links">
                    <span className="mobile-only">戻る</span>
                    <span className="mobile-hide">一覧に戻る</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default QuestionHeader;
